import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementType } from "../../../library-js/dom-tools/ElementType";

export class MembersInfo
{
  static readonly type = new ElementType( "members-info" );
  static readonly ntStyle = new ClassFlag( "nt-style" );
  static readonly tnStyle = new ClassFlag( "tn-style" );

  static readonly ntStyleElement = new ElementType( "nt-style" ); 
  static readonly tnStyleElement = new ElementType( "tn-style" ); 
}